import React, { useEffect, useRef } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { webSocketUrl } from "../../../Utils/constService";

const StompSubscriber = ({ asset, onMessage }) => {
  const clientRef = useRef(null);

  useEffect(() => {
    if (!asset?.uuid) return;

    if (clientRef.current) {
      console.log("Already connected, skipping re-init");
      return;
    }

    const client = new Client({
      webSocketFactory: () => new SockJS(`${webSocketUrl}/api/ws`),
      reconnectDelay: 5000,
      debug: (str) => console.log("[STOMP]", str),
      onConnect: () => {
        console.log("Connected to WebSocket");

        client.subscribe(`/topic/${asset.uuid}`, (message) => {
          const body = JSON.parse(message.body);
          console.log("Received:", body);
          if (onMessage) onMessage(body);
        });
      },
      onDisconnect: () => {
        console.log("STOMP disconnected");
      },
      onStompError: (frame) => {
        console.error("Broker error:", frame.headers["message"]);
      },
    });

    client.activate();
    clientRef.current = client;

    return () => {
      if (clientRef.current) {
        console.log("Disconnected WebSocket");
        clientRef.current.deactivate();
        clientRef.current = null;
      }
    };
  }, [asset?.subTopicName]);

  return null;
};

export default StompSubscriber;
